module.exports = __webpack_public_path__ + "img/Slide40.91d1d9d8.png";